<div class="policy-category disabled">

  <div class="policy-item">
    <i class="policy-number">1</i>
    <radio-question [data]="haveTicketMachines.data" [valueSelected]="haveTicketMachines.valueSelected"
                    (selectAnswer)="onHaveTicketMachinesSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">2</i>
    <radio-question [data]="cancelUphold.data" [active]="haveTicketMachines.valueSelected === 'y'"
                    [valueSelected]="cancelUphold.valueSelected"
                    (selectAnswer)="onCancelUpholdSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">3</i>
    <radio-question [data]="machineMethod.data" [active]="haveTicketMachines.valueSelected === 'y'"
                    [valueSelected]="machineMethod.valueSelected"
                    (selectAnswer)="onMachineMethodSelected($event)"></radio-question>
    <br />
    <div class="default-text" [innerHTML]="textCopy.complaintDaysTitle"></div>
    <input aria-label=""  class="app-input policy-input" type="text" [(ngModel)]="complaintDays"
           [disabled]="haveTicketMachines.valueSelected !== 'y' || machineMethod.valueSelected !== '1'" />
  </div>

  <div class="policy-item">
    <i class="policy-number">4</i>
    <div class="default-text large" [innerHTML]="textCopy.machineFaultyTitle"></div>
    <div class="default-text" [innerHTML]="textCopy.machineFaultySubtitle"></div>
    <input aria-label=""  class="app-input policy-input" type="text" [(ngModel)]="faultyMachine"
           [disabled]="haveTicketMachines.valueSelected !== 'y'" />
    <br />
    <radio-question [data]="faultyMachinePolicy.data" [active]="haveTicketMachines.valueSelected === 'y'"
                    [valueSelected]="faultyMachinePolicy.valueSelected"
                    (selectAnswer)="onFaultyMachinePolicySelected($event)"></radio-question>
    <br />
    <div class="default-text" [innerHTML]="textCopy.fewDaysTitle"></div>
    <input aria-label=""  class="app-input policy-input" type="text" [(ngModel)]="fewDays"
           [disabled]="haveTicketMachines.valueSelected !== 'y' || faultyMachinePolicy.valueSelected === '0'" />
    <br />
    <radio-question [data]="acceptFaultyMachine.data" [active]="haveTicketMachines.valueSelected === 'y'"
                    [valueSelected]="acceptFaultyMachine.valueSelected"
                    (selectAnswer)="onAcceptFaultyMachineSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">5</i>
    <radio-question [data]="refund.data" [active]="haveTicketMachines.valueSelected === 'y'"
                    [valueSelected]="refund.valueSelected"
                    (selectAnswer)="onRefundSelected($event)"></radio-question>
    <br />
    <div class="default-text" [innerHTML]="textCopy.safeguardTitle"></div>
    <span class="default-title">&#163;</span>
    <input aria-label=""  class="app-input policy-input" type="text" [(ngModel)]="safeguard"
           [disabled]="haveTicketMachines.valueSelected !== 'y'" />
  </div>

  <div class="policy-item">
    <i class="policy-number">6</i>
    <radio-question [data]="other.data" [active]="haveTicketMachines.valueSelected === 'y'"
                    [valueSelected]="other.valueSelected"
                    (selectAnswer)="onOtherSelected($event)"></radio-question>
    <br />
    <radio-question [data]="whatPolicy.data" [active]="haveTicketMachines.valueSelected === 'y'"
                    [valueSelected]="whatPolicy.valueSelected"
                    (selectAnswer)="onWhatPolicySelected($event)"></radio-question>
    <br />
    <radio-question [data]="expiredTicket.data" [active]="haveTicketMachines.valueSelected === 'y'"
                    [valueSelected]="expiredTicket.valueSelected"
                    (selectAnswer)="onExpiredTicketSelected($event)"></radio-question>
  </div>

  <br />
  <div class="submit-layer">
    <input aria-label=""  type="submit" class="app-submit" value="Save"
           (click)="submitPolicyCategory()" />
  </div>

</div>
